import { createResourceApi } from 'resources/ResourceApi';
import { BedApiItem } from 'features/Bed/types';

export const apiKey = 'beds';

export default createResourceApi<BedApiItem>('beds');
